// ─── Catalogue des onglets et hubs de navigation SIRH-CMOB ────────────────
// Ces constantes sont exportées et utilisées par GestionAcces, App, et les hubs.

export const ONGLETS_CATALOGUE = [
  // Hub Personnel
  { key:'fiches',         hub:'personnel',    icon:'👥', label:'Fiches salariés',         fixe:true  }, // fixe = ne peut pas être déplacé
  { key:'organigramme',   hub:'personnel',    icon:'🏛️', label:'Organigramme',  horsHub:true }, // toujours standalone — ne pas déplacer dans un hub
  { key:'effectifs',      hub:'personnel',    icon:'📊', label:'Effectifs Club' },
  { key:'onboarding',     hub:'personnel',    icon:'🔑', label:'Onboarding' },
  { key:'notes',          hub:'personnel',    icon:'📝', label:'Notes RH' },
  { key:'anniversaires',  hub:'personnel',    icon:'🎂', label:'Anniversaires' },
  { key:'paie',           hub:'personnel',    icon:'💶', label:'Paie & Rémunérations' },
  { key:'formations',     hub:'personnel',    icon:'🏆', label:'Formations' },
  { key:'plan-formation', hub:'personnel',    icon:'🎓', label:'Plan de formation' },
  // Hub Planning
  { key:'unifie',         hub:'planning-hub', icon:'🗓', label:'Planning unifié',          fixe:true },
  { key:'evenements',     hub:'planning-hub', icon:'📅', label:'Événements CMOB', horsHub:true },
  { key:'horaires',       hub:'planning-hub', icon:'⏰', label:'Horaires & Pointage' },
  // Hub Vie au travail
  { key:'conges',         hub:'vie-travail',  icon:'🌴', label:'Congés & Soldes',          fixe:true },
  { key:'absences',       hub:'vie-travail',  icon:'🚨', label:'Absences non planifiées' },
  { key:'medecine',       hub:'vie-travail',  icon:'🏥', label:'Médecine du travail' },
  { key:'entretiens',     hub:'vie-travail',  icon:'💬', label:'Entretiens professionnels' },
  { key:'objectifs',      hub:'vie-travail',  icon:'🎯', label:'Objectifs & Évaluations' },
  // Hub Contrats & Légal
  { key:'contrats',       hub:'contrats-hub', icon:'📜', label:'Contrats & Avenants',      fixe:true },
  { key:'rup',            hub:'contrats-hub', icon:'📒', label:'Registre du Personnel' },
  { key:'cartepro',       hub:'contrats-hub', icon:'🪪', label:'Cartes Pro & Diplômes' },
  { key:'duerp',          hub:'contrats-hub', icon:'⚠️', label:'DUERP',              roles:['admin','rh'] },
  { key:'cse',            hub:'contrats-hub', icon:'🗳️', label:'CSE',                roles:['admin','rh'], horsHub:false },

  // Hub Collaboration
  { key:'reunions',       hub:'collaboration', icon:'🎙️', label:'Réunions',                fixe:true },
  { key:'communication',  hub:'collaboration', icon:'📢', label:'Annonces & Messages' },
  { key:'messagerie',     hub:'collaboration', icon:'✉️',  label:'Messagerie' },
  { key:'ged',            hub:'collaboration', icon:'🗄️', label:'GED' },
  { key:'basedocs',       hub:'collaboration', icon:'📁', label:'Base documentaire' },
  { key:'workflows',      hub:'collaboration', icon:'🔄', label:'Workflows' },
  { key:'affichage',      hub:'collaboration', icon:'📌', label:'Affichage réglementaire' },

  // Hub Club & Sections
  { key:'benevoles',      hub:'club-hub',     icon:'🤝', label:'Bénévoles',                fixe:true },
  { key:'adherents',      hub:'club-hub',     icon:'🏅', label:'Adhérents' },
  { key:'sections',       hub:'club-hub',     icon:'🏟', label:'Espaces sections' },
  { key:'comptabilite',   hub:'club-hub',     icon:'💰', label:'Comptabilité' },
  // Hub Reporting
  { key:'kpis',           hub:'reporting-hub', icon:'📊', label:'Indicateurs RH',          fixe:true },
  { key:'bilan',          hub:'reporting-hub', icon:'📑', label:'Bilan social' },
  { key:'export',         hub:'reporting-hub', icon:'⬇️', label:'Export complet' },
  // Hub Admin
  { key:'parametres',     hub:'admin-hub',    icon:'⚙️', label:'Paramètres',               fixe:true },
  { key:'acces',          hub:'admin-hub',    icon:'🔐', label:'Gestion des accès' },
  { key:'infos-asso',     hub:'admin-hub',    icon:'🏢', label:'Infos association' },
  { key:'alertes',        hub:'admin-hub',    icon:'🔔', label:'Alertes & Notifications' },
  { key:'import',         hub:'admin-hub',    icon:'⬆️', label:'Import données' },
  { key:'historique',     hub:'admin-hub',    icon:'📋', label:'Historique' },
  { key:'test-email',     hub:'admin-hub',    icon:'🧪', label:'Test emails' },
  { key:'organisation',   hub:'admin-hub',    icon:'🗂', label:'Organisation des modules' },
  { key:'purge', hub:'admin-hub', icon:'🗑️', label:'Purge des données' },
  { key:'modeles-emails', hub:'admin-hub', icon:'✉️', label:'Modèles d\'emails' },
  { key:'monitoring',     hub:'admin-hub', icon:'🖥️', label:'Monitoring VPS' },
  { key:'sharepoint',     hub:'admin-hub', icon:'☁️', label:'Gestion SharePoint',  roles:['admin'] },
];

// Hubs disponibles comme destinations (pour le sélecteur de déplacement)
export const HUBS_LISTE = [
  { key:'personnel',    label:'👥 Personnel & RH' },
  { key:'planning-hub', label:'📅 Planning' },
  { key:'vie-travail',  label:'🌴 Vie au travail' },
  { key:'contrats-hub', label:'📜 Contrats & Légal' },
  { key:'collaboration',label:'🗄️ Collaboration & Docs' },
  { key:'club-hub',     label:'🏅 Club & Sections' },
  { key:'reporting-hub',label:'📊 Reporting' },
  { key:'admin-hub',    label:'⚙️ Administration' },
];

// Résout la config dynamique : retourne les onglets d'un hub dans l'ordre
